import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import axios from 'axios'
import { setdata, setisLoggedin } from '../redux/reducers/userSlice'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const checkSession = async () => {
    try {
      const response = await axios.get(`https://pro-shop-backend.vercel.app/api/users/isLoggedin`);
      
      if (response.data.success === true) {
        dispatch(setisLoggedin(true))
        const profileResponse = await axios.get(`https://pro-shop-backend.vercel.app/api/users/profile`);
        dispatch(setdata(profileResponse.data.user))
      } else {
        dispatch(setisLoggedin(false))
        dispatch(setdata(null))
        navigate("/login")
      }
    } catch (error) {
 
      dispatch(setisLoggedin(false))
      dispatch(setdata(null))
      navigate("/login")
    }
  }

  useEffect(() => {
    checkSession()
  }, [])

  return children;
};

export default ProtectedRoute;